const mocks = {
  config: {
    cantPasos: 2,
    pasos: {
      paso1: {
        path: "/",
        component: "views/Paso1",
        paso: 1,
        pasoSiguiente: "paso2",
        titulo: "Completá el formulario",
        subtitulo: "Ingresá tus datos, luego solicitá el cambio de banco.",
        subtitulo2:
          "Comenzá a acreditar tu jubilación ANSES en BBVA y te regalamos otra de $160.000"
      },
      paso2: {
        path: "/paso2",
        component: "views/Paso2",
        paso: 2,
        pasoSiguiente: "paso2",
        nombreSiguiente: "Confirmar",
        titulo: "Datos de tu comercio",
        subtitulo: "Por último, ayudanos a conocer tu comercio:"
      },
      gracias: {
        path: "/gracias",
        component: "views/Gracias"
      },
      mensaje: {
        path: "/mensaje/:mje",
        component: "views/Mensaje"
      }
    }
  }
};

export default mocks;
